"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.initialValue = exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
const initialValue = {
  isLargeDesktop: null,
  isDesktop: null,
  isLargeMobile: null,
  isMediumMobile: null,
  isTablet: null,
  prefersReducedMotion: null
};
exports.initialValue = initialValue;
const QueryContext = /*#__PURE__*/React.createContext(initialValue);
QueryContext.displayName = "QueryOrbitContext";
var _default = QueryContext;
exports.default = _default;